import script from "./Select.vue?vue&type=script&setup=true&lang=js"
export * from "./Select.vue?vue&type=script&setup=true&lang=js"

import "./Select.vue?vue&type=style&index=0&id=4c1e5407&lang=css"

const __exports__ = script;

export default __exports__